import { faArrowRotateBack, faCircleCheck, faEye, faFileArrowUp, faPencil, faStar, faTrashCan, faXmark } from '@fortawesome/pro-light-svg-icons'
import { faStar as faStarSolid } from '@fortawesome/pro-solid-svg-icons'
import { CustomerProjectStatusModelType } from '@teinor/erp/types/company/customer/customerProjectStatus'
import { Fragment, SetStateAction, useCallback, useEffect, useMemo, useState } from 'react'
import { connect, ConnectedProps } from 'react-redux'
import { EditCardTabsHorizontalWithoutLinks } from '../../../baseComponents/EditCardTabs'
import { ModalWithCloseButton } from '../../../baseComponents/Modal'
import { ModalEditComponentProps } from '../../../baseComponents/ModalsLayouts/types'
import TwinIcon, { TwinIconToolTip } from '../../../baseComponents/TwinIcon'
import { RowData } from '../../../baseComponents/TwinTable/types'
import CustomSelectColor from '../../../forms/CustomSelect/CustomSelectColor'
import TextArea, { TextAreaDebounce } from '../../../forms/Input/TextArea'
import { twinFetchPostJSON } from '../../../utils/globals/data'
import { displayDate } from '../../../utils/globals/date'
import { dictionaryComplexFromJsonArr, TwinDictionary } from '../../../utils/globals/dictionary'
import withLoading from '../../../utils/hoc/withLoading'
import { ComponentTabObject } from '../../../utils/hooks/useTabLogic'
import useTwinTranslation from '../../../utils/hooks/useTwinTranslation'
import { AllReduxPayloads } from '../../../utils/reducers'
import { EmployeesPayload } from '../../../utils/reducers/company/employees'
import { getAllCustomerProjectTypes, getAllTaskTypes, getEmployees, getGroups, getISOCurrencyMain, getModulesBuyed, getTaskCFields, getUserPermissions } from '../../../utils/reducers/getters'
import { GroupPayload } from '../../../utils/reducers/groups/groups'
import { CustomSelectMultipleImageStateFull } from '../../../forms/CustomSelect/CustomSelectMultipleImage'
import CustomerProjectActivityTab from './CustomerProjectActivityTab'
import CustomerProjectCommentTab from './CustomerProjectCommentTab'
import CustomerProjectTaskTab from './CustomerProjectTaskTab'
import CustomerProjectChecklistTab from './CustomerProjectChecklistTab'
import { CustomerProjectModelTypeExtended, SetCustomerProjectDataTy } from './types'
import { TaskCFieldPayload } from '../../../utils/reducers/company/taskCFields'
import { CustomerProjectTypePayload } from '../../../utils/reducers/customers/customerProjectTypes'
import { sortEmployeesByUserForProject, sortGroupsByUserForProject } from './functions'
import { ButtonDisabledOrLoader } from '../../../baseComponents/Button'
import useIsLoading from '../../../utils/hooks/useIsLoading'
import { OnSubmit } from '../../../forms/TwinForm/types'
import TwinTrans from '../../../baseComponents/TwinTrans'
import { SingleTaskInnerConnect, useSingleTaskLogic } from '../../Task/SingleTask'
import { changeErrorMessage, changeSuccessMessage } from '../../../utils/reducers/reduxDispatch'
import { ModalOpenedSetTy } from '../../../baseComponents/Modal/types'
import { CustomSelectWithSearchBar } from '../../../forms/CustomSelect'
import { Link } from 'react-router-dom'
import { CustomerTypesInversedKeys } from '@teinor/erp/types/company/customer/customerTypes'
import useEditDeleteModal, { SetEditDeleteModalTy } from '../../../utils/hooks/useEditDeleteModal'
import ModalDesactiveCustomerProject from './ModalDesactiveCustomerProject'
import ModalReactivateCustomerProject from './ModalReactivateCustomerProject'
import { permissionCheck } from '../../../baseComponents/PermissionChecker/function'
import { listenSocket, unlistenSocket } from '../../../utils/globals/socket'
import { InputCalendarWithHoursStateLess } from '../../../forms/Input/InputCalendarWithHours'
import HeaderTask from '../../Task/SingleTask/HeaderTask'
import ModalCustomerProjectChecklistLog from './ModalCustomerProjectChecklistLog'
import { InputNumberWithLabelMarginTextRightDebounce } from '../../../forms/Input'
import { InputPriceDebounce } from '../../../forms/Input/InputPrice'
import DisplayPrice from '../../../baseComponents/Displays/DisplayPrice'
import PermissionChecker from '../../../baseComponents/PermissionChecker'
import CustomerProjectQuoteTab from './CustomerProjectQuoteTab'
import TwinToolTip from '../../../baseComponents/TwinToolTip'
import { UserPermissionsSingle } from '../../../baseComponents/CreateRoutering/types'
import './modaleditcustomerprojectactivity.sass'
import { haveModuleBuyed } from '../../../utils/globals'
import { useCustomerParsedLinkMemo } from '../../../utils/hooks/customer/useCustomerTypesDict'
import { checkFloatValid } from '../../../utils/globals/numbers'
import ModalCreateCustomerProjectFromOpp from '../ModalCreateProjectFromOpp'
import { CustomerProjectModelType, projectTypes, projectTypesInversed, ProjectTypesInversedKeys, ProjectTypesKeys } from '@teinor/erp/types/company/customer/customerProject'
import { useParseCustomerProjectTypeByStatusSimple } from '../../../utils/hooks/customer/useProjectsAndOpportunitiesDict'

interface ModalEditCustomerProjectProps extends ModalEditComponentProps { }

const ModalEditCustomerProject: React.FC<ModalEditCustomerProjectProps> = ({ allRowData, setOpened, onSubmit }) => {
    const { customerProjectData, getCustomerProject, setCustomerProjectData, selectedTaskId, setSelectedTaskId, returnModal } = useModalEditCustomerProjectLogic({ allRowData: allRowData || {}, setOpened })
    if (!customerProjectData) {
        return null
    }
    const havePermissions = getUserPermissions('customer.projects.main') || undefined
    return (
        <ModalWithCloseButton size='modal_big' opened={true} setOpened={setOpened} className='flex flex-col modal_edit_customerProject' onClickOut={false} showCloseButton={selectedTaskId ? true : false} setOpenedReturn={returnModal}>
            {selectedTaskId ? 
                <CustomerProjectSingleTask selectedTaskId={selectedTaskId} setSelectedTaskId={setSelectedTaskId} returnModal={returnModal} />
                : <CustomerProjectMain onSubmit={onSubmit} setSelectedTaskId={setSelectedTaskId} getCustomerProject={getCustomerProject} allRowData={allRowData || {}} customerProjectData={customerProjectData} setCustomerProjectData={setCustomerProjectData} setOpened={setOpened} userPermissions={havePermissions}/>
            }
        </ModalWithCloseButton>
    )
}

interface ModalEditCustomerProjectLogicProps {
    allRowData: RowData
    setOpened: ModalOpenedSetTy
}

const useModalEditCustomerProjectLogic = ({ allRowData, setOpened }: ModalEditCustomerProjectLogicProps) => {
    const [selectedTaskId, setSelectedTaskId] = useState<number | null>(null)
    const [customerProjectData, setCustomerProjectData] = useState<CustomerProjectModelTypeExtended | null>(null)
    const id = allRowData.id

    const getCustomerProject = useCallback(async () => {
        const result = await twinFetchPostJSON('/api/app/customer/customerProject/getCustomerProjectInstanceComplete', { id })
        if (result) {
            setCustomerProjectData(() => {
                const itemsEmployees: string[] = []
                const itemsGroups: string[] = []
                const dictCustomerProjectStatusHistory = dictionaryComplexFromJsonArr(result?.CustomerProjectStatusHistories, 'CustomerProjectStatusId', undefined, true)
                for (const element of result.Employees) {
                    itemsEmployees.push(String(element.id))
                }
                for (const element of result.Groups) {
                    itemsGroups.push(String(element.id))
                }

                return {
                    ...result,
                    dataSelectedEmployees: itemsEmployees,
                    dataSelectedGroups: itemsGroups,
                    customerProjectStatusesHistoryDict: dictCustomerProjectStatusHistory
                }
            })
        }
    }, [setCustomerProjectData, id])

    const returnModal = useCallback(() => {
        if (selectedTaskId) {
            setSelectedTaskId(null)
        } else {
            setOpened(null)
        }
    }, [setOpened, selectedTaskId, setSelectedTaskId])

    useEffect(() => {
        getCustomerProject()
    }, [getCustomerProject])

    useEffect(() => {
        listenSocket('customerProject-' + id, getCustomerProject, true)
        return () => {
            unlistenSocket('customerProject-' + id)
        }
    }, [getCustomerProject, id])

    return { customerProjectData, getCustomerProject, setCustomerProjectData, selectedTaskId, setSelectedTaskId, returnModal }
}

interface CustomerProjectSingleTaskProps extends CustomerProjectSingleTaskLogicProps {
    selectedTaskId: number
    setSelectedTaskId: React.Dispatch<React.SetStateAction<number | null>>
}

const CustomerProjectSingleTask: React.FC<CustomerProjectSingleTaskProps> = ({ selectedTaskId, setSelectedTaskId, ...logic }) => {
    const { onInvalidPermissions, onDeletedTask } = useCustomerProjectSingleTaskLogic({ ...logic })
    const { refSubTask, data: dataSingleTask, updateTask, setData, customerDicts, changeDescription, changeName, openModalInvertedTime, setOpenModalInvertedTime } = useSingleTaskLogic({ id: String(selectedTaskId), onInvalidPermissions, onDeletedTask })
    const employees = getEmployees()
    const groups = getGroups()
    const taskCFields = getTaskCFields()
    const taskTypes = getAllTaskTypes()
    if (!dataSingleTask){
        return null
    }
    return (
        <div className='flex flex-auto single_task'>
            <div className={'flex flex-col w-full overflow-auto'}>
                <HeaderTask data={dataSingleTask} {...{ refSubTask, updateTask, setData, onDeletedTask, setOpenModalInvertedTime }} />
                <SingleTaskInnerConnect data={dataSingleTask} setSelectedSubtaskId={setSelectedTaskId} {...{ updateTask, setData, changeDescription, changeName, refSubTask, customerDicts, openModalInvertedTime, setOpenModalInvertedTime, employees, groups, taskCFields, taskTypes }} />
            </div>
        </div>
    )
}

interface CustomerProjectSingleTaskLogicProps {
    returnModal: ()=>void
}
const useCustomerProjectSingleTaskLogic = ({ returnModal }: CustomerProjectSingleTaskLogicProps) => {
    const { t } = useTwinTranslation()
    const taskNotAvailable = t('taskNotAvailable', 'Esta tarea no está disponible')
    const taskDeleted = t('taskDeletedSuccessfully', 'Tarea eliminada con éxito')
    const taskHasBeenDeleted = t('taskHasBeenDeleted', 'Esta tarea ha sido eliminada')

    const onInvalidPermissions = useCallback(() => {
        changeErrorMessage(taskNotAvailable)
    }, [taskNotAvailable])

    const onDeletedTask = useCallback((otherPerson?: boolean) => {
        if (otherPerson) {
            changeErrorMessage(taskHasBeenDeleted)
        } else {
            changeSuccessMessage(taskDeleted)
        }
        returnModal()
    }, [taskDeleted, taskHasBeenDeleted, returnModal])

    return { onInvalidPermissions, onDeletedTask }
}

interface CustomerProjectMainProps extends CustomerProjectMainLogicProps {
    setSelectedTaskId: React.Dispatch<SetStateAction<number | null>>
    setOpened: ModalOpenedSetTy
    getCustomerProject: () => Promise<void>
    userPermissions?: UserPermissionsSingle
}

const CustomerProjectMain: React.FC<CustomerProjectMainProps> = ({ allRowData, onSubmit, setSelectedTaskId, customerProjectData, setCustomerProjectData, getCustomerProject, userPermissions}) => {
    const { t } = useTwinTranslation()
    const { setTabActive, tabActive, onChangeCustomerProjectDescription, projectStatuses } = useCustomerProjectMainLogic({ allRowData: allRowData || {}, setCustomerProjectData, customerProjectData, onSubmit})
    const userPermissionTask = getUserPermissions('task.main')
    const userPermissionChecklist = getUserPermissions('customer.projects.checklists')
    const userPermissionQuote = getUserPermissions('quote.order')
    const tabs: ComponentTabObject = {
        'activity': { component: CustomerProjectActivityTab, text: t('activity', 'Actividad') },
    }
    if (permissionCheck(userPermissionTask, 'read')) {
        tabs.tasks = { component: CustomerProjectTaskTab, text: t('tasks', 'Tareas') }
    }
    tabs.comments = { component: CustomerProjectCommentTab, text: t('comments', 'Comentarios') }
    if (permissionCheck(userPermissionChecklist, 'read')){
        tabs.checklist = { component: CustomerProjectChecklistTab, text: < ListTextTab CustomerProjectId={allRowData?.id} />, permission: 'customer.projects.checklists' }
    }
    if (permissionCheck(userPermissionQuote, 'read') && haveModuleBuyed(['quotes'], getModulesBuyed())) {
        tabs.quote = { component: CustomerProjectQuoteTab, text: t('quotes', 'Presupuestos'), permission: 'quote.order', modules: ['quotes'] }
    }
    return (
        <div className='modal_edit_cproject flex-auto flex flex-col'>
            <CustomerProjectTitle {...{ setCustomerProjectData, customerProjectData, onSubmit, getCustomerProject, userPermissions }} />
            <CustomerProjectFirstHeader customerProjectData={customerProjectData} getCustomerProject={getCustomerProject} id={allRowData?.id} myCustomerProjectStatusesDict={projectStatuses.myCustomerProjectStatusesDict} onSubmit={onSubmit} userPermissions={userPermissions}/>
            <CustomerProjectStatusBar CurrentCProjectStatusId={customerProjectData.CurrentCProjectStatusId} customerProjectStatusesHistoryDict={customerProjectData.customerProjectStatusesHistoryDict} myCustomerProjectStatusesArr={projectStatuses.myCustomerProjectStatusesArr} />
            <TextAreaDebounce className='mt-15 w-full mr-15 modal_edit_customer_project_description' name='description' value={customerProjectData?.description || ''} onChange={onChangeCustomerProjectDescription} label={t('description', 'Descripción')} readOnly={!permissionCheck(userPermissions || false, 'update')} />
            <EditCardTabsHorizontalWithoutLinks tabs={tabs} tab={tabActive} onClick={setTabActive} extraComponentData={{ customerProjectData, getCustomerProject, setSelectedTaskId, setCustomerProjectData }} className='customer_project_tabs mt-15 flex_tabs' />
        </div>
    )
}

interface CustomerProjectMainLogicProps {
    onSubmit: OnSubmit
    allRowData: RowData
    customerProjectData: CustomerProjectModelTypeExtended
    setCustomerProjectData: SetCustomerProjectDataTy
}

const useCustomerProjectMainLogic = ({ customerProjectData, setCustomerProjectData, allRowData, onSubmit }: CustomerProjectMainLogicProps) => {
    const [tabActive, setTabActive] = useState('activity')
    const id = allRowData.id
    

    const projectStatuses = useMemo(() => {
        const customerProjectTypes = getAllCustomerProjectTypes()
        const CustomerProjectTypeId = customerProjectData?.CustomerProjectTypeId
        if(CustomerProjectTypeId){
            const customerProjectType = customerProjectTypes?.[CustomerProjectTypeId]
            if (customerProjectType) {
                const myProjectTypeKey = projectTypes[customerProjectData.projectType as ProjectTypesKeys] as ProjectTypesInversedKeys
                const myCustomerProjectStatusesDict = customerProjectType?.customerProjectStatusDict[myProjectTypeKey] || {}
                const myCustomerProjectStatusesArr = customerProjectType.CustomerProjectStatusesByType[myProjectTypeKey] || []
                return { myCustomerProjectStatusesDict, myCustomerProjectStatusesArr }
            }
            const CurrentCProjectStatus = customerProjectData?.CurrentCProjectStatus
            if (CurrentCProjectStatus) {

                return { myCustomerProjectStatusesDict: { [CurrentCProjectStatus.id]: CurrentCProjectStatus }, myCustomerProjectStatusesArr: [CurrentCProjectStatus]}
            }
        }
        return { myCustomerProjectStatusesDict: {}, myCustomerProjectStatusesArr: [] }
    }, [customerProjectData?.CustomerProjectTypeId, customerProjectData?.CurrentCProjectStatus, customerProjectData.projectType])

    const onChangeCustomerProjectDescription = useCallback(async (value: string) => {
        setCustomerProjectData((old) => {
            if (!old) {
                return null
            }
            return { ...old, description: value }
        })
        const res = await twinFetchPostJSON('/api/app/customer/customerProject/updateCustomerProject', {
            id,
            description: value
        })
        onSubmit(res, {})
    }, [id, setCustomerProjectData, onSubmit])

    return { tabActive, setTabActive, projectStatuses, onChangeCustomerProjectDescription }
}


interface CustomerProjectTitleProps extends CustomerProjectTitleLogicProps {
    userPermissions?: UserPermissionsSingle
}

const CustomerProjectTitle: React.FC<CustomerProjectTitleProps> = ({customerProjectData, setCustomerProjectData, userPermissions, ...logic}) => {
    const { loading, openModal, setOpenModal, setTitle, updateNameProject, title, handleActiveProject } = useCustomerProjectTitleLogic({ customerProjectData, setCustomerProjectData, ...logic })
    const { t } = useTwinTranslation()
    if (openModal?.type === 'edit') {
        return (
            <div className='flex items-center gap-x-5'>
                <TextArea className='w-full pb-15' value={title} onChange={setTitle} />
                <ButtonDisabledOrLoader onClick={updateNameProject} loading={loading} buttonIsDisabled={title === '' || customerProjectData?.name === title} textButton={t('save', 'Guardar')} />
                <TwinIcon className='ml-10 cursor-pointer hover:text-red-BA' icon={faXmark} onClick={() => setOpenModal(null)} />
            </div>
        )
    }
    return (
        <div className='flex flex-wrap gap-10'>
            <div className='flex flex-col mr-auto'>
                <div className='flex-row flex items-center'>
                    <h2 className='twin_elipsis max-w-300' data-tooltip-id={'customer_project_title'}>{title}</h2>
                    <TwinToolTip content={title} id='customer_project_title' />
                    <PermissionChecker userPermissions={userPermissions || false} permission={'update'}>
                        <TwinIcon className='ml-10 cursor-pointer hover:text-green-43 h-15' icon={faPencil}  onClick={() => setOpenModal({type: 'edit', allRowData: {} })} />
                        <ButtonsDisableProject active={customerProjectData?.active || false} projectType={customerProjectData.projectType} {...{ setOpenModal }} />
                        {customerProjectData?.active && customerProjectData.projectType === projectTypesInversed['opportunity'] ? <ButtonsConvertToProject handleOnSubmit={handleActiveProject} customerProject={customerProjectData} /> : null}
                    </PermissionChecker>
                </div>
                <div className='mt-10'>
                    <CustomerNameAndRatingStars customerProjectData={customerProjectData} userPermissions={userPermissions}/>
                </div>
            </div>
            {!customerProjectData?.hidePrices ? <CustomerProjectSecondHeader customerProjectData={customerProjectData} userPermissions={userPermissions}/> : null}
            {openModal?.type ==='delete' ? 
                <ModalDesactiveCustomerProject allRowData={{ id: customerProjectData?.id }} setOpened={() => setOpenModal(null)} onSubmit={()=>handleActiveProject(false)} />
            : null}
            {openModal?.type ==='create' ? 
                <ModalReactivateCustomerProject allRowData={{ id: customerProjectData?.id }} setOpened={() => setOpenModal(null)} onSubmit={() => handleActiveProject(true)} />
            : null}
        </div>
    )
}

interface CustomerProjectTitleLogicProps {
    setCustomerProjectData: React.Dispatch<React.SetStateAction<CustomerProjectModelTypeExtended | null>>
    customerProjectData: CustomerProjectModelTypeExtended
    onSubmit: OnSubmit
    getCustomerProject: () => Promise<void>
}

const useCustomerProjectTitleLogic = ({ setCustomerProjectData, customerProjectData, onSubmit, getCustomerProject }: CustomerProjectTitleLogicProps) => {
    const { openModal, setOpenModal } = useEditDeleteModal()
    const [title, setTitle] = useState(customerProjectData?.name || '')
    const { startLoading, endLoading, loading } = useIsLoading()

    const updateNameProject = useCallback(async () => {
        startLoading()
        const res = await twinFetchPostJSON('/api/app/customer/customerProject/updateCustomerProject', { name: title, id: customerProjectData?.id })
        setCustomerProjectData((old) => {
            if (!old) {
                return null
            }
            return { ...old, name: title }
        })
        endLoading()
        onSubmit(res, {})
        setOpenModal(null)
    }, [startLoading, endLoading, title, customerProjectData?.id, setCustomerProjectData, onSubmit, setOpenModal])

    const handleActiveProject = useCallback(async (val: boolean) => {
        setCustomerProjectData((old) => {
            if (!old) {
                return null
            }
            return { ...old, active: val }
        })
        getCustomerProject()
        onSubmit({} as Response, {})
    }, [setCustomerProjectData, onSubmit, getCustomerProject])

    return { loading, openModal, setOpenModal, setTitle, updateNameProject, title, handleActiveProject }
}

interface ButtonsDisableProjectProps {
    active: boolean
    setOpenModal: SetEditDeleteModalTy
    projectType: number
}

const ButtonsDisableProject: React.FC<ButtonsDisableProjectProps> = ({active, setOpenModal, projectType}) => {
    const {t} = useTwinTranslation()
    if(!active){
        return(
            <TwinIconToolTip id='disableProject' message={projectType === projectTypesInversed['project'] ? t('reactivateProject', 'Reactivar proyecto') : t('reactivateOpportunity', 'Reactivar oportunidad')} className='ml-5 h-20' classNameIcon='hover:text-red-BA' icon={faArrowRotateBack} onClick={() => setOpenModal({ type: 'create', allRowData: {} })} />
        )
    }
    return (
        <TwinIconToolTip id='disableProject' message={projectType === projectTypesInversed['project'] ? t('disableProject', 'Desactivar proyecto') : t('disableOpportunity', 'Desactivar oportunidad')} className='ml-5 h-20' classNameIcon='hover:text-red-BA' icon={faTrashCan} onClick={() => setOpenModal({ type: 'delete', allRowData: {} })}/>
    )
}

interface ButtonsConvertToProjectProps {
    handleOnSubmit: (value: boolean) => Promise<void>
    customerProject: CustomerProjectModelType
 }

const ButtonsConvertToProject: React.FC<ButtonsConvertToProjectProps> = ({handleOnSubmit, customerProject}) => {
    const { t } = useTwinTranslation()
    const { openModal, setOpenModal } = useEditDeleteModal()
    return (
        <Fragment>
            <TwinIconToolTip id='createProject' message={t('turnIntoProject', 'Convertir a proyecto')} className='ml-5 h-20' classNameIcon='hover:text-green-43' icon={faFileArrowUp} onClick={() => setOpenModal({ type: 'edit', allRowData: {} })} />
            {openModal?.type === 'edit' ?
                <ModalCreateCustomerProjectFromOpp allRowData={customerProject} setOpened={() => setOpenModal(null)} onSubmit={() => { handleOnSubmit(true) }} />
                : null}
        </Fragment>
    )
}

interface CustomerNameAndRatingStarsProps extends CustomerNameAndRatingStarsLogicProps { 
    userPermissions?: UserPermissionsSingle
}

const CustomerNameAndRatingStars: React.FC<CustomerNameAndRatingStarsProps> = ({ customerProjectData, userPermissions }) => {
    const { activeStar, handleOnChangeCustomerRatingStars, parsedLinkMemo } = useCustomerNameAndRatingStarsLogic({ customerProjectData })
    const renderThis: JSX.Element[] = []
    for (let i = 1; i < 5 + 1; i++) {
        renderThis.push(
            <div key={i} onClick={() =>  permissionCheck(userPermissions || false, 'update') ?  handleOnChangeCustomerRatingStars(i) : undefined}>
                <TwinIcon icon={i <= activeStar ? faStarSolid : faStar} className={'text-green-43 mr-4 ' + (permissionCheck(userPermissions || false, 'update') ? 'cursor-pointer' : '')}fontSize={17} />
            </div>
        )
    }
    return (
        <div className='flex items-center'>
            <Link to={parsedLinkMemo}><h2 className='cursor-pointer text-gray-51 hover:text-green-21 text-16  font-light mr-10'>{customerProjectData?.Customer?.name}</h2></Link>
            {renderThis}
        </div>
    )
}

interface CustomerNameAndRatingStarsLogicProps {
    customerProjectData: CustomerProjectModelTypeExtended | null
}

const useCustomerNameAndRatingStarsLogic = ({ customerProjectData }: CustomerNameAndRatingStarsLogicProps) => {
    const [activeStar, setActiveStar] = useState(customerProjectData?.rating || 0)

    const handleOnChangeCustomerRatingStars = useCallback(async (value: any) => {
        setActiveStar(value)
        await twinFetchPostJSON('/api/app/customer/customerProject/updateCustomerProject', {
            id: customerProjectData?.id,
            rating: value
        })
    }, [customerProjectData?.id])

    const typeCustomer: CustomerTypesInversedKeys = customerProjectData?.Customer?.customer_type || 0
    const { parsedLinkMemo } = useCustomerParsedLinkMemo({ id: customerProjectData?.Customer?.id || 0, customer_type: typeCustomer })
    return { activeStar, handleOnChangeCustomerRatingStars, parsedLinkMemo }
}

interface CustomerProjectFirstHeaderProps extends CustomerProjectFirstHeaderLogicProps {
    myCustomerProjectStatusesDict: TwinDictionary
    customerProjectData: CustomerProjectModelTypeExtended
    userPermissions?: UserPermissionsSingle
}

const CustomerProjectFirstHeader: React.FC<CustomerProjectFirstHeaderProps> = ({ customerProjectData, myCustomerProjectStatusesDict, getCustomerProject, id, onSubmit , userPermissions}) => {
    const { t } = useTwinTranslation()
    const { handleOnChangeCustomerProjectLimitDate, handleOnChangeCustomerProjectStatus, handleOnAddEmployeeSelector, handleOnDeleteEmployeeSelector, handleOnAddGroupSelector, handleOnDeleteGroupSelector, employees, groups, customerProjectsTypes, handleChangeCustomerProjectType } = useCustomerProjectFirstHeaderLogic({ getCustomerProject, id, customerProjectData, onSubmit })
    const hasUpdatePermissions = permissionCheck(userPermissions || false, 'update')
    return (
        <div className='mt-18 flex items-start justify-between customer_project_first_header'>
            <div className='mr-4 flex gap-10'>
                <CustomSelectMultipleImageStateFull itemsSelected={customerProjectData?.dataSelectedEmployees} defaultImage='/user-png.png' items={employees || {}} sortFunction={sortEmployeesByUserForProject} onAdd={handleOnAddEmployeeSelector} onDelete={handleOnDeleteEmployeeSelector} label={t('employeesAssigned', 'Empleados asignados')} type={'Employees'} fieldImage='profile_image' fieldName='fullname_short' readOnly={!hasUpdatePermissions}/>
                <CustomSelectMultipleImageStateFull itemsSelected={customerProjectData?.dataSelectedGroups} defaultImage='/group.png' items={groups || {}} sortFunction={sortGroupsByUserForProject} onAdd={handleOnAddGroupSelector} onDelete={handleOnDeleteGroupSelector} label={t('groupsAssigned', 'Grupos asignados')} type={'Groups'} readOnly={!hasUpdatePermissions} />
            </div>
            <div className='flex flex-auto gap-10 customer_project_header_inputs'>
                <div className='w-full'>
                    <InputCalendarWithHoursStateLess label={t('limitDate', 'Fecha límite')} value={customerProjectData?.limit_date ? new Date(customerProjectData?.limit_date) : undefined} onChange={handleOnChangeCustomerProjectLimitDate} onDeleteDate={() => handleOnChangeCustomerProjectLimitDate('')} readOnly={!hasUpdatePermissions} />
                </div>
                <CustomSelectColor items={myCustomerProjectStatusesDict} value={customerProjectData?.CurrentCProjectStatusId} label={t('changeStatus', 'Cambiar de estado')} onChange={handleOnChangeCustomerProjectStatus} readOnly={!hasUpdatePermissions} />
                <CustomSelectWithSearchBar className='w-full' items={customerProjectsTypes} value={customerProjectData?.CustomerProjectTypeId} label={(customerProjectData.projectType === projectTypesInversed['project']) ? t('projectType', 'Tipo de proyecto') : t('opportunityType', 'Tipo de oportunidad')} onChange={handleChangeCustomerProjectType} readOnly={!hasUpdatePermissions} />
            </div>
        </div>
    )
}

interface CustomerProjectFirstHeaderLogicProps {
    onSubmit: OnSubmit
    getCustomerProject: () => Promise<void>
    id: number
    customerProjectData: CustomerProjectModelTypeExtended
}

const useCustomerProjectFirstHeaderLogic = ({ getCustomerProject, id, customerProjectData, onSubmit }: CustomerProjectFirstHeaderLogicProps) => {
    const employees = useMemo(() => getEmployees() || {}, [])
    const groups = useMemo(() => getGroups() || {}, [])
    const { parsedCustomerProjectTypes } = useParseCustomerProjectTypeByStatusSimple()
    const customerProjectsTypes = useMemo(() => { 
        const items = getAllCustomerProjectTypes() || {}
        const copyItems = JSON.parse(JSON.stringify((customerProjectData.projectType === projectTypesInversed['project']) ? items : parsedCustomerProjectTypes(items, projectTypesInversed['opportunity'] as ProjectTypesKeys)))
        const CustomerProjectType  = customerProjectData.CustomerProjectType
        const CurrentCProjectStatus = customerProjectData.CurrentCProjectStatus
        if (CustomerProjectType && !copyItems[CustomerProjectType.id]){
            const customerProjectStatusDict: TwinDictionary = {}
            if (CurrentCProjectStatus){
                customerProjectStatusDict[CurrentCProjectStatus.id] = CurrentCProjectStatus
            }
            copyItems[CustomerProjectType.id] = {
                ...CustomerProjectType, customerProjectStatusDict
            }
        }
        return {...copyItems}
    }, [customerProjectData.CustomerProjectType, customerProjectData.CurrentCProjectStatus, customerProjectData.projectType, parsedCustomerProjectTypes])
    const handleOnAddEmployeeSelector = useCallback(async (value: string) => {
        const result = await twinFetchPostJSON('/api/app/customer/customerProject/assignCustomerProjectEmployee', {
            CustomerProjectId: id,
            EmployeeId: value
        })
        if (result) {
            getCustomerProject()
        }
    }, [id, getCustomerProject])

    const handleOnDeleteEmployeeSelector = useCallback(async (value: string) => {
        const result = await twinFetchPostJSON('/api/app/customer/customerProject/removeCustomerProjectEmployee', {
            CustomerProjectId: id,
            EmployeeId: value
        })
        if (result) {
            getCustomerProject()
        }
    }, [id, getCustomerProject])
    const handleOnAddGroupSelector = useCallback(async (value: string) => {
        const result = await twinFetchPostJSON('/api/app/customer/customerProject/assignCustomerProjectGroup', {
            CustomerProjectId: id,
            GroupId: parseInt(value)
        })
        if (result) {
            getCustomerProject()
        }
    }, [id, getCustomerProject])

    const handleOnDeleteGroupSelector = useCallback(async (value: string) => {
        const result = await twinFetchPostJSON('/api/app/customer/customerProject/removeCustomerProjectGroup', {
            CustomerProjectId: id,
            GroupId: parseInt(value)
        })
        if (result) {
            getCustomerProject()
        }
    }, [id, getCustomerProject])

    const handleOnChangeCustomerProjectLimitDate = useCallback(async (value: any) => {
        await twinFetchPostJSON('/api/app/customer/customerProject/updateCustomerProject', {
            id,
            limit_date: value
        })
    }, [id])

    const handleOnChangeCustomerProjectStatus = useCallback(async (CurrentCProjectStatusId: string) => {
        const res = await twinFetchPostJSON('/api/app/customer/customerProject/updateCustomerProjectCurrentStatus', {
            id,
            CurrentCProjectStatusId
        })
        getCustomerProject()
        onSubmit(res, {})
    }, [id, getCustomerProject, onSubmit])

    const handleChangeCustomerProjectType = useCallback(async (value: any) => {
        const CPStatusId = customerProjectsTypes[value]?.CustomerProjectStatusesByType[projectTypes[customerProjectData.projectType]]?.[0]?.id
        const result = await twinFetchPostJSON('/api/app/customer/customerProject/changeTypeCustomerProject', {
            CustomerProjectId: id,
            CustomerProjectTypeId: value,
        })
        if (result) {
            if (CPStatusId) {
                handleOnChangeCustomerProjectStatus(CPStatusId)
            }
            getCustomerProject()
            onSubmit(result, {})
        }
    }, [id, getCustomerProject, onSubmit, handleOnChangeCustomerProjectStatus, customerProjectData.projectType, customerProjectsTypes])

    return { handleOnAddEmployeeSelector, handleOnDeleteEmployeeSelector, handleOnAddGroupSelector, handleOnDeleteGroupSelector, handleOnChangeCustomerProjectLimitDate, handleOnChangeCustomerProjectStatus, employees, groups, customerProjectsTypes, handleChangeCustomerProjectType }
}


interface CustomerProjectSecondHeaderProps extends CustomerProjectSecondHeaderLogicProps {
    userPermissions?: UserPermissionsSingle
 }

const CustomerProjectSecondHeader: React.FC<CustomerProjectSecondHeaderProps> = ({ customerProjectData, userPermissions,  ...logic }) => {
    const { handleOnChangeField } = useCustomerProjectSecondHeaderLogicProps({ customerProjectData, ...logic })
    const { t } = useTwinTranslation()
    const CurrencyId = getISOCurrencyMain()
    const hasUpdatePermissions = permissionCheck(userPermissions || false, 'update')
    return (
        <div className='flex gap-10 flex-wrap'>
            <div className='bg-green-DB flex gap-10 rounded-8 p-15 cp_second_header_price_box'>
                <InputPriceDebounce CurrencyId={CurrencyId} label={t('estimate', 'Estimación')} value={String(customerProjectData?.aproxAmount || 0)} className='w-150 cp_second_header_input_price' onChange={(value) => handleOnChangeField('aproxAmount', value) } readOnly={!hasUpdatePermissions } />
                <InputNumberWithLabelMarginTextRightDebounce maxValue={100} label={t('closingProbability', 'Prob. de cierre')} value={String(customerProjectData?.percentage || 0)} textRight={'%'} className='w-100 percentage_input' onChange={(value) => handleOnChangeField('percentage', value)} classNameTextRight='regular14' readOnly={!hasUpdatePermissions} />
            </div>
            <div className='bg-green-DB flex gap-10 rounded-8 cp_second_header_total_amount_box'>
                <div className='p-15 flex flex-col gap-y-5 cp_second_header_total_amount'>
                    <span className='light12 cp_second_header_total_amount_label '><TwinTrans transKey={'estimatedImport'}>Importe estimado</TwinTrans></span>
                    <DisplayPrice value={customerProjectData?.percentageValue || 0} CurrencyId={CurrencyId} with_vat={false} calculateParams={{
                        decimals: 2,
                        rounding: '0.01',
                        roundingPriceType: 'medium'
                    }} className='w-auto min-w-100 text-start regular16 total_amount_price'></DisplayPrice>
                </div>
            </div>
        </div>
    )
}
interface CustomerProjectSecondHeaderLogicProps {
    customerProjectData: CustomerProjectModelTypeExtended
}
const useCustomerProjectSecondHeaderLogicProps = ({ customerProjectData }: CustomerProjectSecondHeaderLogicProps) => {
    const handleOnChangeField = useCallback(async (field: 'aproxAmount' | 'percentage', value: string) => {
        const parseValue = parseFloat(value)
        const percentageValue = field === 'aproxAmount' ? ((customerProjectData?.percentage || 0) * parseValue) / 100 : ((customerProjectData?.aproxAmount || 0) * parseValue) / 100
        await twinFetchPostJSON('/api/app/customer/customerProject/updateCustomerProject', {
            id: customerProjectData?.id,
            [field]: checkFloatValid(value),
            percentageValue
        })
    }, [customerProjectData?.id, customerProjectData?.aproxAmount, customerProjectData?.percentage])

    return { handleOnChangeField }
}

interface CustomerProjectStatusBarProps  {
    CurrentCProjectStatusId: number
    customerProjectStatusesHistoryDict: TwinDictionary
    myCustomerProjectStatusesArr: CustomerProjectStatusModelType[]
}

const CustomerProjectStatusBar: React.FC<CustomerProjectStatusBarProps> = ({ CurrentCProjectStatusId, myCustomerProjectStatusesArr, customerProjectStatusesHistoryDict }) => {
    const renderThis: JSX.Element[] = []
    let lastDate: null | Date = null
    let isColored = CurrentCProjectStatusId ? true : false
    for (const element of myCustomerProjectStatusesArr) {
        const finishedDate = customerProjectStatusesHistoryDict[element.id]?.finishedDate
        let displayDateDate = finishedDate ? new Date(finishedDate) : null
        if (!lastDate && displayDateDate) {
            lastDate = displayDateDate
        }
        if (displayDateDate && lastDate && displayDateDate < lastDate) {
            displayDateDate = null
        } else if(displayDateDate) {
            lastDate = displayDateDate
        }
        const isCurrentStatus = CurrentCProjectStatusId === element.id 
        if (isCurrentStatus) {
            const createdAt = customerProjectStatusesHistoryDict[element.id]?.createdAt
            displayDateDate = new Date(createdAt)
        }
        renderThis.push(
            <CustomerProjectStatusBox name={element.name} displayDate={isColored && displayDateDate ? displayDate(displayDateDate) : ''} color={isColored ? element.color : '#D9D9D9'} hasIcon={!isCurrentStatus} key={element.id}/>
        )
        if (isCurrentStatus) {
            isColored = false
        }
    }
    return (
        <div className='mt-23 flex gap-2 overflow-auto'>
            {renderThis}
        </div>
    )
}

interface CustomerProjectStatusBoxProps {
    displayDate?: string
    name: string
    color?: string
    hasIcon?: boolean
}

const CustomerProjectStatusBox: React.FC<CustomerProjectStatusBoxProps> = ({ displayDate, name, color, hasIcon }) => {
    return (
        <div className='flex flex-col customer_project_status_box p-10 bg-gray-F7 border-t-4' style={{borderColor: color}}>
            <span className='text-gray-51 text-14 twin_elipsis'>{name}</span>
            {displayDate ? <div className='flex justify-between items-center h-24'>
                <span className='text-gray-51 text-12 font-light mr-40'>{displayDate}</span>
                {hasIcon ? <TwinIcon icon={faCircleCheck} className='text-green-43 w-20 h-20'></TwinIcon> : null}
            </div> : null}
        </div>
    )
}

interface ListTextTabProps extends ListTextTabLogicProps {}

const ListTextTab: React.FC<ListTextTabProps> = ({ ...logic }) => {
    const { openModal, setOpenModal, handleOpenChecklistLog } = useListTextTabLogic({ ...logic })
    const userPermissionLogs = getUserPermissions('customer.projects.checklistLogs')
    const hasChecklistLogs = permissionCheck(userPermissionLogs, 'read')
    return (
        <div className='flex items-center' >
            <span>
                <TwinTrans transKey='lists'>Listas</TwinTrans>
            </span>
            {hasChecklistLogs ?
                <TwinIcon className='ml-10 hover:text-green-21 text-12' icon={faEye} onClick={handleOpenChecklistLog} />
                : null
            }
            {openModal?.type === 'edit' ?
                <ModalCustomerProjectChecklistLog {...{ setOpened: () => setOpenModal(null), onSubmit: () => { } }} allRowData={openModal.allRowData} />
                : null
            }
        </div>
    )
}

interface ListTextTabLogicProps {
    CustomerProjectId: number
}

const useListTextTabLogic = ({ CustomerProjectId }: ListTextTabLogicProps) => {
    const { openModal, setOpenModal } = useEditDeleteModal()

    const handleOpenChecklistLog: React.MouseEventHandler<SVGSVGElement> = useCallback(async (e) => {
        e.preventDefault()
        const myLogs = await twinFetchPostJSON('/api/app/customer/customerProject/customerProjectChecklist/getAllCPChecklistLogs', { where: { CustomerProjectId } })
        if (myLogs) {
            setOpenModal({ type: 'edit', allRowData: { CPChecklistLogs: myLogs } })
        }
    }, [setOpenModal, CustomerProjectId])
    return { openModal, setOpenModal, handleOpenChecklistLog }
}

const customerEmployeeGroupDispatch = {
    setGroups: (payload: GroupPayload) => ({ type: 'CHANGE_GROUP', payload }),
    setEmployees: (payload: EmployeesPayload) => ({ type: 'CHANGE_EMPLOYEE', payload }),
    setTaskCFields: (payload: TaskCFieldPayload) => ({ type: 'CHANGE_TASKCFIELD', payload }),
    setCustomerProjectTypes: (payload: CustomerProjectTypePayload) => ({ type: 'CHANGE_CUSTOMER_PROJECT_TYPES', payload }),
}

export type ReduxCustomerEmployeeGroup= ConnectedProps<typeof customerEmployeeGroupConnect>
const mapCustomerEmployeeGroupConnector = (state: AllReduxPayloads) => ({ groups: state.groups, employees: state.employees, taskCFields: state.taskCFields, customerProjectTypes: state.customerProjectTypes })
const customerEmployeeGroupConnect = connect(mapCustomerEmployeeGroupConnector, customerEmployeeGroupDispatch)

const customerEmployeeGroupConnectLoading = withLoading(ModalEditCustomerProject, [{ fetchUrl: '/api/app/group/getAllGroupsListing', propName: 'groups', setFunctionName: 'setGroups' }, { fetchUrl: '/api/app/employee/getAllEmployees', propName: 'employees', setFunctionName: 'setEmployees' }, { fetchUrl: '/api/app/task/customField/getAllTaskCFieldsComplete', propName: 'taskCFields', setFunctionName: 'setTaskCFields' }, { fetchUrl: '/api/app/customer/customerProject/customerProjectTypes/getAllCustomerProjectTypesFull', propName: 'customerProjectTypes', setFunctionName: 'setCustomerProjectTypes' }])

const ModalEditCustomerProjectConnect = customerEmployeeGroupConnect(customerEmployeeGroupConnectLoading)

export default ModalEditCustomerProjectConnect